import { createTypes } from 'redux-create-types';
import { 
    map2UserObj,
} from 'imports/mapper';
import * as auth from 'imports/auth';
import { ajaxJson } from 'imports/ajax';
import { userActionCreators } from 'db/user/user.action'
import history from 'imports/history';
import * as moment from 'moment-jalaali';

const namespace = 'page-enrolment-profile';

export const enrolmentProfilePageActions = createTypes([
    'toggleSpinner',
    'setError',
], namespace);

function showSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: enrolmentProfilePageActions.toggleSpinner,
            payload: true,
            meta: {apiName}
        });
    }
}

function hideSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: enrolmentProfilePageActions.toggleSpinner,
            payload: false,
            meta: {apiName}
        });
    }
}

function getUserApiFail(err) {
    return dispatch => {
        dispatch({
            type: enrolmentProfilePageActions.setError,
            payload: err,
        })
        return dispatch(hideSpinner('get-user'));
    }
}

function getUserApiSuccess(res) {
    return dispatch => {
        const userObj = map2UserObj(res.data);
        auth.login({
            token: res.data['access_token'],
            ...userObj
        });
        return dispatch(userActionCreators.set(userObj));
    }
}

function getUserFromApi() {
    return dispatch => {
        dispatch(showSpinner('get-user'));
        return ajaxJson.get('/users')
        .then(
            res => dispatch(getUserApiSuccess(res)),
            err => dispatch(getUserApiFail(err)),
        )
        .then(() => {
            return dispatch(hideSpinner('get-user'));            
        })
    }
}

function putUserApiFail(err, formActions, birthday) {
    return dispatch => {
        dispatch({
            type: enrolmentProfilePageActions.setError,
            payload: err,
        })
        if (err.response && err.response.status === 400) {
            const birthdayMoment = moment(new Date(birthday));
            let birthdayError = (err.response.data["birthday_date"] || null);
            if (birthdayError === null && birthdayMoment && !birthdayMoment.isValid()) {
                birthdayError = 'تاریخ نا معتبر است.'
            }
            formActions.setErrors({
                firstName: err.response.data["first_name"] || null,
                lastName: err.response.data["last_name"] || null,
                email: err.response.data["email"] || null,
                address: err.response.data["address"] || null,
                major: err.response.data["major"] || null,
                birthday: birthdayError,
                educationDegree: err.response.data["education_degree"] || null,
                postalCode: err.response.data["postal_code"] || null,
                university: err.response.data["university"] || null,
                jobTitle: err.response.data["job_title"] || null,
                jobPosition: err.response.data["occupational_field"] || null,
            });
        }
        formActions.setSubmitting(false);
        return dispatch(hideSpinner('update-user'));
    }
}

function putUserApiSuccess(res, programId, formActions) {
    return dispatch => {
        formActions.resetForm();
		history.push(`/enrollment/${programId}`);
        return dispatch(hideSpinner('update-user'));
    }
}

function putUserToApi(userData, programId, formActions) {
    return dispatch => {
        dispatch(showSpinner('update-user'));        
        const bodyData = {
            "first_name": userData.firstName,
            "last_name": userData.lastName,
            "email": userData.email,
            "address": userData.address,
            "education_degree": userData.educationDegree,
            "major": userData.major,
            "university": userData.university,
            "birthday_date": userData.birthday,
            "postal_code": userData.postalCode,
            "job_title": userData.jobTitle,
            "occupational_field": userData.jobPosition,
        }
        return ajaxJson.put(`/programs/${programId}/enrollment/user_information`, bodyData)
        .then(
            res => dispatch(putUserApiSuccess(res, programId, formActions)),
            err => dispatch(putUserApiFail(err, formActions, userData.birthday)),
        )
    }
}

export const enrolmentProfilePageActionsCreators = {
    getUserFromApi,
    putUserToApi,
}